export default function Advanced() {
  return (
    <div className="container mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold mb-6">Chess Advanced</h1>
      <p className="text-lg">Learn the fundamentals of chess...</p>
    </div>
  );
}